import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { RootState } from '$store/rootReducer';
import { GiftsState } from '$store/gifts/interface';
import { LoadingStatus } from '$store/reels/interface';
import { GiftModel } from '$store/models';

const initialState: GiftsState = {
  loadingStatus: 'loading',
  gifts: [],
  specialIds: [],
  specialTitle: '',
  send: null,
};

export const { actions, reducer } = createSlice({
  name: 'gifts',
  initialState,
  reducers: {
    loadGifts: (state, _: PayloadAction<number>) => {
      state.loadingStatus = 'loading';
    },
    setLoadingStatus(state, action: PayloadAction<LoadingStatus>) {
      state.loadingStatus = action.payload;
    },
    setGifts(state, action: PayloadAction<GiftModel[]>) {
      state.gifts = action.payload;
    },
    setSpecial(state, action: PayloadAction<{ title: string; gifts: number[] }>) {
      state.specialIds = action.payload.gifts;
      state.specialTitle = action.payload.title;
    },
    showSend(state, action: PayloadAction<{ toId: number; gift: GiftModel }>) {
      state.send = action.payload;
    },
  },
});

export { reducer as giftsReducer, actions as giftsActions };

export const giftsSelector = (state: RootState) => state.gifts;
